import React, { useContext } from "react";
import { isTrue } from "service/service";
import moment from "moment";
import { DiscussDetail, getDurationSeconds } from "service/discuss";
import styles from "./index.module.scss";
import { DiscussContent } from "../../../../context";

interface TimeLimitProps {
    data: DiscussDetail;
}

export default function TimeLimit({ data }: TimeLimitProps) {
    const seconds = getDurationSeconds(data);
    const { isDead } = useContext(DiscussContent);

    if (!seconds) return null;

    if (isDead) {
        return <span className={styles.over}>当前讨论已截止</span>;
    }

    if (isTrue(data.isStart) && moment(data.deadline).isAfter()) {
        return (
            <span className={styles.limit}>
                当前讨论将于:&nbsp;
                {moment
                    .duration(moment(data.deadline).diff(moment()))
                    .humanize()}
                后截止
            </span>
        );
    }

    return null;
}
